import {Service} from "@/services/Service";

export class VersionCheckService extends Service{
    private currentTimestamp: string | null = null;

    public async checkForUpdate(): Promise<boolean> {
        try {
            const response = await fetch('/timestamp.txt?t=' + Date.now());
            const newTimestamp = await response.text();

            if (this.currentTimestamp === null) {
                this.currentTimestamp = newTimestamp.trim();
                return false;
            }

            if (newTimestamp.trim() !== this.currentTimestamp) {
                this.currentTimestamp = newTimestamp.trim();
                return true;
            }

            return false;
        } catch (error) {
            console.warn('Failed to check for updates:', error);
            return false;
        }
    }
}
